var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    { staticClass: "bg-white shadow py-5 px-3 mb-4" },
    [
      _c(
        "vs-col",
        { attrs: { "vs-lg": "11" } },
        [
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                { staticClass: "text-center", attrs: { "vs-lg": "2" } },
                [_c("b", [_vm._v("#")])]
              ),
              _c("vs-col", { attrs: { "vs-lg": "2" } }, [
                _c("b", [_vm._v("Estado")])
              ]),
              _c(
                "vs-col",
                { attrs: { "vs-lg": "8" } },
                [
                  _c(
                    "vs-row",
                    [
                      _c("vs-col", { attrs: { "vs-lg": "3" } }, [
                        _c("b", [_vm._v("Enviado por")])
                      ]),
                      _c("vs-col", { attrs: { "vs-lg": "3" } }, [
                        _c("b", { staticClass: "ml-6" }, [_vm._v("Creado por")])
                      ]),
                      _vm.onPendingFiles
                        ? _c("vs-col", { attrs: { "vs-lg": "3" } }, [
                            _c("b", [_vm._v("Derivado por")])
                          ])
                        : _vm._e(),
                      !_vm.onPendingFiles
                        ? _c("vs-col", { attrs: { "vs-lg": "6" } }, [
                            _c("b", [_vm._v("Resumen")])
                          ])
                        : _vm._e(),
                      _vm.onPendingFiles
                        ? _c(
                            "vs-col",
                            {
                              attrs: {
                                "vs-lg": "3",
                                "vs-md": "3",
                                "vs-sm": "3",
                                "vs-xs": "12"
                              }
                            },
                            [_c("b", [_vm._v("Resumen")])]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "vs-col",
        {
          staticClass: "text-center",
          attrs: { "vs-lg": "1", "vs-sm": "4", "vs-xs": "12" }
        },
        [
          !_vm.exportable ? _c("b", [_vm._v("...")]) : _vm._e(),
          _vm.exportable
            ? _c("font-awesome-icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip",
                    value: "Descargar Listado",
                    expression: "'Descargar Listado'"
                  }
                ],
                staticClass: "action-icon",
                staticStyle: { cursor: "pointer" },
                attrs: {
                  icon: ["fas", "download"],
                  "data-cy": "download-list"
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("export-list", true)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }